export enum ExchangeOinCreationEnum {
  AUTOMATICALLY = "automatically",
  MANUALLY = "manually",
}
